const ResponsiveMenu = (function () {
  function init() {
    $('#nav').addClass('collapsed').before('<div id="menu"><span class="fa fa-bars"></span> Menu</div>');
    $('#menu').click(() => {
      $('#nav').slideToggle('fast');
    });
    $(window).resize(() => {
      if (window.innerWidth > 641) {
        $('#nav').removeAttr('style');
      }
    });
  }

  return {
    init,
  };
}());

$(() => { ResponsiveMenu.init(); });



// WEBPACK FOOTER //
// ./src/components/legacy/responsive-menu.js